
export default {
  name: 'SearchBar',
  components: {},
  mixins: [],
  props: [],
  asyncData: {},
  data() {
    return {
      question: '',
    }
  },
  computed: {},
  mounted() {},
  methods: {
    searchQuestion() {
      this.$emit('result', this.question)
    },
  },
}
